// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "ServiceSlide-module--wrapper--75oPl";
export var infoWrapper = "ServiceSlide-module--infoWrapper--tZ2hq";
export var sectionTitle = "ServiceSlide-module--sectionTitle--owv2S";
export var serviceName = "ServiceSlide-module--serviceName--cnNMf";
export var list = "ServiceSlide-module--list--6qGKn";
export var listTitle = "ServiceSlide-module--listTitle--Bd5bN";
export var image = "ServiceSlide-module--image--W-ECg";
export var appointmentTypesWrapper = "ServiceSlide-module--appointmentTypesWrapper--7gD0z";
export var body = "ServiceSlide-module--body--aj3uW";
export var title = "ServiceSlide-module--title--qqfrb";
export var button = "ServiceSlide-module--button--8eh+5";